import { parseAsNativeArrayOf, parseAsString, useQueryState } from "nuqs";
import { useMemo, useCallback } from "react";

/** URL パラメータ名 */
const PARAM_NAME = "area";

// nuqs parser for area filter (?area=slug1&area=slug2)
const areaFilterParser = parseAsNativeArrayOf(parseAsString);

/**
 * エリアフィルタの状態管理とURL同期を行うカスタムフック
 *
 * - nuqs を使用して URL パラメータと状態を同期
 * - エリアの slug で管理
 */
export function useAreaFilter() {
  const [urlFilter, setUrlFilter] = useQueryState(PARAM_NAME, areaFilterParser);

  // URL の文字列配列を Set<string> に変換
  // nuqs の useMemo により、URL が変わらない限り同じ参照を返す
  const areaFilter = useMemo(
    () => new Set(urlFilter.filter((param) => param.length > 0)),
    [urlFilter],
  );

  const setAreaFilter = useCallback(
    (filter: Set<string>) => {
      const filterArray = Array.from(filter);
      void setUrlFilter(filterArray.length > 0 ? filterArray : null);
    },
    [setUrlFilter],
  );

  return {
    /** 現在のエリアフィルタ状態（slug の Set） */
    areaFilter,
    /** フィルタ更新関数（状態とURLを同期更新） */
    setAreaFilter,
  };
}
